import { z } from 'zod';
export const DSLMatchAllQueryDTO = z.object({
  match_all: z.record(z.string(), z.never()).optional(),
});

export type DSLMatchAllQuery = z.infer<typeof DSLMatchAllQueryDTO>;